import { getProgressDetails } from "./../../config/progressConfigs";

export default function ProgressDetails({ event }) {
  const details = getProgressDetails(event);

  if (details.length === 0) {
    return null;
  }

  return (
    <div className="progress-details">
      {details.map((detail) => (
        <div
          className="progress-details__line"
          key={detail.key}
        >
          {detail.label && (
            <span className="progress-details__label">
              {detail.label}: {" "}
            </span>
          )}

          <span className="progress-details__value">
            {detail.value}
          </span>
        </div>
      ))}
    </div>
  );
}
